import { colors, fonts, layout, spacing, gradients } from '../theme';

const styles = {
  cardWrapper: {
    background: gradients.blueToGreen,
    padding: '2px',
    borderRadius: layout.borderRadius,
    boxShadow: layout.boxShadow,
  },
  card: {
    backgroundColor: colors.white,
    padding: layout.cardPadding,
    borderRadius: 'calc(19px - 2px)',
    transition: 'all 0.2s ease',
  },
  cardHover: {
    boxShadow: '0px 6px 20px 0px rgba(0, 99, 160, 0.15)',
    transform: 'translateY(-2px)',
  },
  wrapperHover: {
    boxShadow: '0px 6px 20px 0px rgba(0, 99, 160, 0.15)',
  },
  header: {
    marginBottom: spacing.lg,
    paddingBottom: spacing.md,
    borderBottom: `1px solid ${colors.gray200}`,
  },
  title: {
    fontFamily: fonts.heading,
    fontSize: '1.5rem',
    fontWeight: 600,
    color: colors.darkGray,
    margin: 0,
  },
  body: {
    color: colors.darkGray,
  },
  footer: {
    marginTop: spacing.lg,
    paddingTop: spacing.md,
    borderTop: `1px solid ${colors.gray200}`,
  },
};

const variants = {
  default: {},
  elevated: {
    boxShadow: '0px 8px 24px 0px rgba(0, 99, 160, 0.12)',
  },
  outlined: {
    boxShadow: 'none',
    border: `2px solid ${colors.blue}`,
  },
  filled: {
    backgroundColor: colors.gray50,
  },
  gradient: {
    border: `2px solid ${colors.blue}`,
  },
};

function Card({
  children,
  title = null,
  header = null,
  footer = null,
  variant = 'default',
  hoverable = true,
  style = {},
  className = '',
  onClick,
  ...props
}) {
  // Dense admin panels should not lift on hover (causes overlap with neighbors).
  const variantStyle = variants[variant] || variants.default;
  const cardStyle = {
    ...styles.card,
    ...variantStyle,
    cursor: onClick ? 'pointer' : 'default',
    ...style,
  };

  const wrapperStyle = {
    ...styles.cardWrapper,
    ...(onClick ? { cursor: 'pointer' } : {}),
  };

  const handleMouseEnter = (e) => {
    if (hoverable && !onClick) {
      const card = e.currentTarget.querySelector('[data-card-inner]');
      if (card) {
        Object.assign(card.style, {
          boxShadow: styles.cardHover.boxShadow,
          // Intentionally omit translateY — it causes adjacent cards to overlap
        });
      }
    }
  };

  const handleMouseLeave = (e) => {
    if (hoverable && !onClick) {
      const card = e.currentTarget.querySelector('[data-card-inner]');
      if (card) {
        card.style.boxShadow = 'none';
        card.style.transform = 'none';
      }
    }
  };

  return (
    <div
      style={wrapperStyle}
      className={className}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={onClick}
      {...props}
    >
      <div
        data-card-inner
        style={cardStyle}
      >
        {(title || header) && (
          <div style={styles.header}>
            {header || <h2 style={styles.title}>{title}</h2>}
          </div>
        )}
        <div style={styles.body}>{children}</div>
        {footer && <div style={styles.footer}>{footer}</div>}
      </div>
    </div>
  );
}

export default Card;

